import { useEffect, useState } from "react";
import styles from "./ThemeSwitcher.module.css";

export default function ThemeSwitcher() {
    const [selection, setSelection] = useState(() => {
        try {
            const stored = localStorage.getItem("theme");
            if (stored === "light" || stored === "dark" || stored === "high-contrast") {
                return stored;
            }
        } catch { }
        return "light";
    });

    useEffect(() => {
        const root = document.documentElement;
        if (selection === "light" || selection === "dark" || selection === "high-contrast") {
            root.setAttribute("data-theme", selection);
        }
        try {
            localStorage.setItem("theme", selection);
        } catch { }
    }, [selection]);

    useEffect(() => {
        try {
            const stored = localStorage.getItem("theme");
            if (!stored) {
                document.documentElement.removeAttribute("data-theme");
            }
        } catch { }
    }, []);

    return (
        <div className={styles.switcher} role="group">
            <button
                type="button"
                className={`${styles.swatch} ${styles.light}`}
                onClick={() => setSelection('light')}
            />
            <button
                type="button"
                className={`${styles.swatch} ${styles.dark}`}
                onClick={() => setSelection('dark')}

            />
            <button
                type="button"
                className={`${styles.swatch} ${styles.hc}`}
                onClick={() => setSelection('high-contrast')}
            />
        </div>
    );
}
